import React from 'react';
import TableMaterial from '@material-ui/core/Table';

const Table = ({ children, ...rest }: { children: any }) => {
  return <TableMaterial {...rest}>{children}</TableMaterial>;
};

export default Table;
